module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"import":"Jobs import"}}')
  delete Component.options._Ctor
}
